import { render, staticRenderFns } from "./ActorRoleCreateScreen.vue?vue&type=template&id=09049717&"
import script from "./ActorRoleCreateScreen.vue?vue&type=script&lang=js&"
export * from "./ActorRoleCreateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports